module.exports = __webpack_public_path__ + "img/2021y_top1_ts.595a7d7e.jpg";